import { Button } from '@worldcoo/ui/components/button';
import { useTranslation } from '@/lib/i18n';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Animate } from '@worldcoo/ui/custom/animate';
import { useEphemeralStore } from '@/lib/app-store';

export const Route = createFileRoute('/$portalId/$campaignId/donate/thanks')({
	component: RouteComponent,
});

function RouteComponent() {
	const { i18n } = useTranslation();
	const { portalId, campaignId } = Route.useParams();
	const donationConfirmed = useEphemeralStore((store) => store.donationConfirmed);

	return (
		<Animate>
			<div className="text-accent-foreground flex flex-col gap-3">
				<h1 className="text-center text-[40px] leading-[46px] -tracking-[0.2px]">{i18n.thanks.title}</h1>
				<p className="text-center align-middle text-base font-medium">{i18n.thanks.description}</p>
			</div>

			<Button
				size="xl"
				className="mx-auto w-fit"
				asChild
				data-testid="view-campaign-button"
				data-donation-confirmed={donationConfirmed ? 'true' : 'false'}
			>
				<Link to="/$portalId/$campaignId" params={{ portalId, campaignId }} replace>
					{i18n.actions.viewCampaign}
				</Link>
			</Button>
		</Animate>
	);
}
